import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useHomeData } from "../../../lib/useMockData";

export default function StrengthsSection() {
  const { strengthsData } = useHomeData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-14">
              <p className="section-label mb-3">{strengthsData.label}</p>
              <h2 className="section-title">{strengthsData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {strengthsData.items.map((item, idx) => (
              <ScrollReveal key={item.title} direction="up" delay={idx * 80}>
                <div className="p-7 bg-airdoa-cream rounded-lg transition-all duration-300 hover:bg-white hover:shadow-lg">
                  <div className="w-10 h-10 flex items-center justify-center text-airdoa-gold mb-4">
                    <i className={`${item.icon} text-xl`} />
                  </div>
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy">
                    {item.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-airdoa-gray leading-relaxed">{item.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}